<template>
  <div class="asset">
    <div class="asset__header" v-html="title"></div>
    <div class="asset__caption" v-html="subTitle"></div>
    <div class="asset__row">
      <div class="asset__row-number">
        <div class="context" v-for="i in lists.length" :key="i">{{i}}</div>
      </div>
      <div class="asset__row-content">
        <slick-assets
          :obj-user-setting.sync="objUserSetting"
          @callback-func="onCallBack"
        ></slick-assets>
      </div>
    </div>
  </div>
</template>

<script>
import { SlickAssets } from "../Slick"
export default {
  components: {
    SlickAssets
  },
  props: {
    title: {
      type: String,
      default: "",
      required: false
    },
    subTitle: {
      type: String,
      default: "",
      required: false
    },
    objUserSetting: {
      type: Object,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      lists: this.objUserSetting.assets
    }
  },
  methods: {
    onCallBack(obj) {
      this.$emit("callback-func", obj)
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./styles/_OnboardingAsset";
</style>